import MyAccountLayout from "layouts/my-account/my-account-layout";
import MyGoals from "components/partial/myDesk/myDesk-goals/my-goals";
import ProfileLayout from "layouts/private/profile/profile-layout";
import { useRouteUserId } from "hooks/useRouteUserId";

const MyGoalsPage = () => {
	const { routeUserId } = useRouteUserId();
	return routeUserId ? (
		<ProfileLayout>
			<MyGoals/>
		</ProfileLayout>
	) : (
		<MyAccountLayout>
			<MyGoals />
		</MyAccountLayout>
	);
};

export default MyGoalsPage;
